import z from "zod";

import fetcher from "@/lib/fetcher";
import { actionClient } from "@/lib/safe-action";
import handleErrorResponse from "@/lib/handle-error-response";

export const getParentsForMultipleCourses = actionClient
  .inputSchema(
    z.array(
      z
        .object({
          courseId: z.number().describe("Course Id"),
          languageId: z.number().optional().describe("Language Id"),
          lessonId: z.number().optional().describe("Lesson Id"),
        })
        .describe("Array of courses")
    )
  )
  .action(async ({ clientInput }) => {
    const response = await fetcher(
      "/api/app-content-ws/v1/course/getParentsForMultipleCourses",
      {
        method: "POST",
        body: JSON.stringify(clientInput),
      }
    );

    if (!response.ok) return handleErrorResponse(response);

    const data = await response.json();
    if (data.status) return data.data;

    return null;
  });
